import { XVII18nService } from '@app/i18n/services/xvi-translate.service';
import { I18n } from '@app/i18n/strings-keys';
import { getSingularEntityName } from '@app/shared/configs/entity-name-config';
import { observableOf } from '@app/shared/rx';
import { ENTITY_TYPES } from '@app/shared/types/enums/entityTypes.enum';
import { WIDGET_COMPONENT } from '@app/shared/types/enums/widget-component.enum';
import { MODAL_TEMPLATES } from '@app/text-content';
import {
  BTN_CANCEL,
  BTN_CONTINUE,
} from '@app/text-content/button-templates/button-templates-content';
import { WIDGET_FAMILY } from '@config/global-constants';

export const unsavedWhenSwitchModalOptions = (options: {
  i18nService: XVII18nService;
}) => ({
  title: MODAL_TEMPLATES.MODAL_TEMPLATE_CONFIRM.title,
  buttons: [BTN_CONTINUE, BTN_CANCEL],
  value: {
    needToSave: true,
  },
  schema: {
    type: 'object',
    properties: {
      message: {
        type: 'string',
      },
      needToSave: {
        type: 'boolean',
      },
    },
  },
  formRules: {
    fields: {
      message: {
        widget: WIDGET_COMPONENT.label,
        widgetFamily: WIDGET_FAMILY.LEGACY,
        title: options.i18nService.instant(
          I18n.ConfirmMessages.SaveAndProcessUnsavedChanges,
          {
            entityType: options.i18nService.instant(
              getSingularEntityName(ENTITY_TYPES.HAWKER_SESSION),
            ),
          },
        ),
      },
      needToSave: {
        widget: WIDGET_COMPONENT.input_checkbox,
        widgetFamily: WIDGET_FAMILY.XUX,
        titleObs: observableOf(null),
        widgetData: {
          staticTextContent: {
            checked: I18n.Forms.HawkerSessionForm.SaveHawkerSessionChanges,
          },
        },
      },
    },
  },
});
